import { useState } from 'react';

import { data } from './data/data_03_apv_taustoitus'
import kuva from './images/x_ray_300x411.png'

const ApvTaustoitus = ({ visibilityHandler }) => {





    const jatka = () => {

        visibilityHandler("jatka sauvojen tsekkaukseen")

    }



    return (


        <div className='sceneContainer'>

            <div id='image'>
                <img className='sameSizeImg' src={kuva} alt='kuva' />
            </div>

            <div id='teksti'>
                <h5>{(data.kysymysteksti != null && data.kysymysteksti != "") ? data.kysymysteksti : null}</h5>
            </div>

            <div id='actions'>
                <button onClick={() => jatka()}>jatka</button>
            </div>
        </div>

    )

}

export default ApvTaustoitus